import * as Models from "../../ts/rlAdmin.models";
import * as Utils from "../../ts/rlAdmin.utils";
import * as Consts from "../../ts/rlAdmin.consts";
import { BaseSearchController } from "../../controllers/_baseSearchController";
import { LocalCacheService } from "../../services/local-cache-service";
import { NotifyService } from "../../services/notify-service";
import { WorkflowConfigService } from "../../services/workflow-config-service";
import { EntityService } from "../../services/entity-service";
import { WorkflowService } from "../../services/workflow-service";
import { AdminService } from "../../services/admin-service";
import { SearchService } from "../../services/search-service";

export class EntityStatusAdminController extends BaseSearchController<Models.IAssetSearchDoc>{

    static $inject = ["$scope", "$q", "$location", "$filter", "$window",
        "localCacheService", "notifyService", "workflowConfigService", "entityService",
        "workflowService", "adminService", "searchService"];

    selectedEntity: Models.IEntity;
    openSetStatus: boolean;
    allProcesses: Models.IWFProcess[];         // list of processes
    availableStatuses: Models.IWFStepConfig[];
    newStatus: Models.IWFStepConfig;
    statusHistoryItems: Models.IStatusHistoryItem[];

    constructor($scope: ng.IScope, $q: ng.IQService, $location: ng.ILocationService, private $filter: ng.IFilterService, private $window: ng.IWindowService,
        localStorage: LocalCacheService, notifyService: NotifyService, private workflowConfigService: WorkflowConfigService,
        entityService: EntityService, private workflowService: WorkflowService,
        private adminService: AdminService,
        searchService: SearchService) {

        super($scope, $q, $location, $filter, localStorage, notifyService, entityService, searchService);

        this.selectedEntity = <Models.IEntity>{};
        this.openSetStatus = false;
        this.availableStatuses = [];
        this.allProcesses = [];
        this.newStatus = <Models.IWFStepConfig>{};
        this.statusHistoryItems = [];

        $scope.$watch(() => this.selectedEntity,
            (newValue, oldValue) => {
                if (newValue != oldValue && !_.isNull(newValue)) {
                    this.openSetStatus = true;
                }
            }, true);
    }

    LoadStatusHistory() {
        this.notifyService.startProgress();
        this.workflowService.getEntityStatusHistory(this.selectedEntity.id)
            .then((results) => {
                this.statusHistoryItems = results;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }


    LoadProcesses() {
        this.workflowConfigService.getProcesses(-1)
            .then((result) => {
                this.allProcesses = result;
            });
    }

    LoadStatus(entity: Models.IAssetSearchDoc) {
        this.entityService.getEntityRecord(entity.entityID)
            .then((result) => {
                this.selectedEntity = result;
                this.availableStatuses = [];
                this.workflowConfigService.getStatusesForEntity(this.selectedEntity.charTypeID, this.selectedEntity.recordID)
                    .then((output) => {
                        this.availableStatuses = output.statuses;
                        this.newStatus = _.find(this.availableStatuses, s => s.stepID == this.selectedEntity.statusID);
                        this.LoadStatusHistory();
                    });
            });
    }

    SetStatus() {
        this.notifyService.startProgress();
        var request = <Models.IWFEntityStatusUpdateRequest>{};
        request.charTypeID = this.selectedEntity.charTypeID;
        request.recID = this.selectedEntity.recordID;
        request.statusID = this.newStatus.stepID;
        this.workflowService.setEntityStatus(request)
            .then(() => {
                this.notifyService.notifySuccess("Status updated successfully");
                this.adminService.rebuildIndex([], [], [this.selectedEntity.id], null, false)
                    .then(() => {
                        this.RefreshAll();
                    });
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    Init() {
        this.LoadProcesses();
    }

    RefreshAll() {
        this.openSetStatus = false;
        this.search = true;
    }
}
